module.exports = __webpack_public_path__ + "static/media/logo-white.d14aea07.svg";